export default function Style(theme) {
    const style = {
      root: {
        margin: "0 auto"
      },
      pageContainer: {
        marginTop: 75,
      },
      productContainer: {
        margin: "0 auto",
        height: "100%"
      }
    }
      return style
  }